<div class="staff-form-fill" data-testid="staff-form-fill-container">
  @if (savingDraft()) {
    <div class="mb-2 text-right text-sm text-500" data-testid="saving-draft-indicator">
      <i class="pi pi-spin pi-spinner mr-1" aria-hidden="true"></i>
      {{ 'SURVEY_FORMS.SAVING_DRAFT' | translate }}
    </div>
  }

  <div class="surface-0 border-round p-2">
    <survey [model]="surveyModel" data-testid="staff-form-survey"></survey>
  </div>



  @if (completed() && false) {
    <div class="mt-3 p-3 surface-100 border-round flex align-items-center gap-2" data-testid="form-completed-message">
      @if (submitting()) {
        <i class="pi pi-spin pi-spinner text-primary" aria-hidden="true"></i>
        <span>{{ 'SURVEY_FORMS.SUBMITTING' | translate }}</span>
      } @else {
        <i class="pi pi-check-circle text-green-500" aria-hidden="true"></i>
        <span>{{ 'SURVEY_FORMS.FORM_SUBMITTED_MESSAGE' | translate }}</span>
      }
    </div>
  }
</div>
